// API Types (matching our C# DTOs)
export interface GameDto {
  id: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
  winnerId?: string;
  totalMoves: number;
  maxMoves: number;
  players: PlayerDto[];
  currentBoard?: BoardStateDto;
  recentMoves: MoveDto[];
}

export interface PlayerDto {
  id: string;
  username: string;
  rating: number;
  gamesPlayed: number;
  gamesWon: number;
  gamesLost: number;
  gamesDrawn: number;
}

export interface BoardStateDto {
  cells: CellDto[][];
  currentPlayerIndex: number;
  moveCount: number;
  validMoves: number[][];
}

export interface CellDto {
  type: CellType;
  playerIndex?: number;
  yugoCount?: number;
}

export interface MoveDto {
  fromX: number;
  fromY: number;
  toX: number;
  toY: number;
  playerId: string;
  moveNumber: number;
  createdAt: string;
}

export interface MakeMoveDto {
  fromX: number;
  fromY: number;
  toX: number;
  toY: number;
}

export interface MoveResultDto {
  success: boolean;
  error?: string;
  newBoardState?: BoardStateDto;
  gameEnded: boolean;
  winnerId?: string;
}

export interface CreateGameDto {
  maxMoves: number;
  playerIds: string[];
}

export interface LoginDto {
  username: string;
  password: string;
}

export interface RegisterDto {
  username: string;
  email: string;
  password: string;
}

export interface AuthResponseDto {
  accessToken: string;
  refreshToken: string;
  player: PlayerDto;
  expiresAt: string;
}

export enum CellType {
  Empty = 0,
  Migo = 1,
  Nexus = 2,
  Yugo = 3
}

export enum GameMode {
  PvP = 0,
  PvAI = 1,
  AIvAI = 2
}

// Frontend-specific types
export interface GameState {
  game?: GameDto;
  isLoading: boolean;
  isMakingMove?: boolean;
  error?: string;
  currentUser?: PlayerDto;
  isAuthenticated: boolean;
}

export interface UIState {
  selectedCell?: { row: number; col: number };
  theme: Theme;
  showJoinGameModal: boolean;
}

export type Theme = 'classic' | 'dark' | 'high-contrast' | 'nature' | 'felt';

export interface Position {
  row: number;
  col: number;
}